export default function Logo() {
  return <h1 className="logo">Weatherly.</h1>;
}
